var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"border-right border-light",class:{
    'is-floating': _vm.layout.sidebar === 'floating',
    'is-collapsed': _vm.layout.sidebar === 'collapsed',
    'is-expanded': _vm.layout.sidebar === 'expanded',
    'is-active': _vm.active
  },on:{"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.mouseEnter($event)},"mouseleave":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.mouseLeave($event)}}},[_c('nav',[_vm._l((_vm.items),function(group,index){return [_c('Items',{key:index,attrs:{"items":group}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }